import { render, staticRenderFns } from "./menu-tree.vue?vue&type=template&id=f0eeccc2&scoped=true&"
import script from "./menu-tree.vue?vue&type=script&lang=js&"
export * from "./menu-tree.vue?vue&type=script&lang=js&"
import style0 from "./menu-tree.vue?vue&type=style&index=0&id=f0eeccc2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0eeccc2",
  null
  
)

export default component.exports